<template>
  <div>You should have an <code>inline-template</code> directive on the component</div>
</template>

<script>
export default  {
  props: ['defaultSelected'],

  data() {
    return {
      selected: this.defaultSelected
    }
  }

}
</script>